import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { loginWithPassword } from '../utils/auth';
import './LoginForm.css';


const LoginForm = (props) => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [pass, setPass] = useState('');
    const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setError('');
      setLoading(true);

      try {
        await loginWithPassword({
          username: username.trim(),
          password: pass,
        });

        setUsername('');
        setPass('');
        navigate('/clients');
      } catch (requestError) {
        console.error(requestError);
        const message = String(requestError?.message || '').toLowerCase();

        if (message.includes('incorrect') || message.includes('invalid')) {
          setError('Incorrect password or username.');
        } else if (message.includes('not found')) {
          setError('Username does not exist.');
        } else {
          setError(requestError.message || 'Unable to sign in. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    }

    const handlePassChange = (e) => {
      setPass(e.target.value)
      setError(null)
    }

    const handleUsernameChange = (e) => {
      setUsername(e.target.value)
      setError(null)
    }

    return (
      <div className='signin-page'>
        <div className='signin-card'>
          <div className='signin-header'>
            <h2>Sign In</h2>
            <p>Welcome back. Enter your account details to continue.</p>
          </div>

          <form className='signin-form' onSubmit={handleSubmit}>
            <label className='signin-label' htmlFor='username'>Username</label>
            <input
              className='signin-input'
              required
              value={username}
              onChange={handleUsernameChange}
              type='text'
              placeholder='Enter username'
              id='username'
              name='username'
              autoComplete='username'
            />

            <label className='signin-label' htmlFor='password'>Password</label>
            <input
              className='signin-input'
              required
              value={pass}
              onChange={handlePassChange}
              type='password'
              placeholder='Enter password'
              id='password'
              name='password'
              autoComplete='current-password'
            />

            {error ? <div className='signin-error'>{error}</div> : null}

            <button className='signin-button' type='submit' disabled={loading}>
              {loading ? (
                <span className='signin-button-loading'>
                  <span className='signin-button-loader-dot' aria-hidden='true'></span>
                </span>
              ) : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    );
};

export default LoginForm;


